import React, { useState, useEffect } from "react";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";

const AppContent = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error during logout: ", error);
      alert("Failed to log out. Please try again.");
    }
  };

  return (
    <div style={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
      {/* Header with Logout Button */}
      <header
        style={{
          position: "absolute",
          top: 0,
          width: "100%",
          backgroundColor: "#007BFF",
          color: "#fff",
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h1 style={{ margin: 0, fontSize: "1.2rem" }}>Team Member Services</h1>
        {user && (
          <button
            onClick={handleLogout}
            style={{
              backgroundColor: "#fff",
              color: "#007BFF",
              border: "none",
              borderRadius: "3px",
              padding: "5px 10px",
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        )}
      </header>

      {/* Embed the JotForm */}
      <iframe
        src="https://forms.teamdaks.com/app/233249212791961"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          marginTop: "50px", // Adjust for header
        }}
        title="Team Member Services"
      ></iframe>
    </div>
  );
};

export default AppContent;
